// extracted by mini-css-extract-plugin
export default {"input":"Input_input__LsdOm","error":"Input_error__oZr0Q","errorInput":"Input_errorInput__3eOV2","label":"Input_label__9y5UT"};